export default class Datasource {
  id: string;

  name: string;

  main: boolean;

  variablesMetadataUpdatedAt: string | null;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.main = obj.main;
    this.variablesMetadataUpdatedAt = obj.variablesMetadataUpdatedAt || null;
  }

  public static of(obj: any): Datasource {
    return new Datasource(obj || {});
  }

  public static ofList(obj: any[]): Datasource[] {
    return obj.map(this.of);
  }
}
